export const ONLINE_THRESHOLD = 120;
export const MAX_MESSAGES = 100;
export const MAX_EVENTS = 500;
export const MAX_ACTIVITY_EVENTS = 1000;
export const MAX_MISSING = 30;
export const OPENCHAT_VIDEO_CALL_USER_ID = "wp3oc-ig6b4-6xvef-yoj27-qt3kw-u2xmp-qbvuv-2grco-s2ndy-wv3ud-7qe";
export const OPENCHAT_VIDEO_CALL_USERNAME = "VideoCallBot";
export const OPENCHAT_VIDEO_CALL_AVATAR_URL = "/assets/video_call.svg";
export const OPENCHAT_BOT_USER_ID = "zzyk3-openc-hatbo-tq7my-cai";
export const OPENCHAT_BOT_USERNAME = "OpenChatBot";
export const OPENCHAT_BOT_AVATAR_URL = "/assets/robot.svg";
export const AIRDROP_BOT_USERNAME = "AirdropBot";
export const AIRDROP_BOT_AVATAR_URL = "/assets/airdrop_bot.svg";
export const WEBAUTHN_ORIGINATING_CANISTER = "zzzxd-webau-thnke-yr7oc-cai";
export const NOOP = () => { };
export const ROLE_NONE = 0;
export const ROLE_MEMBER = 1;
export const ROLE_MODERATOR = 2;
export const ROLE_ADMIN = 3;
export const ROLE_OWNER = 4;
export const ONE_MINUTE_MILLIS = 60 * 1000;
export const ONE_HOUR = 60 * ONE_MINUTE_MILLIS;
export const ONE_DAY = 24 * ONE_HOUR;
export const ONE_WEEK = ONE_DAY * 7;
export const ONE_MONTH = ONE_WEEK * 4;
export const ONE_YEAR = 365 * ONE_DAY;
// The longest a P2P swap may stay open, which the Escrow canister enforces
export const P2P_SWAP_MAX_EXPIRY_DAYS = 90;
export const LARGE_GROUP_THRESHOLD = 1000;
// The most members of a chat or community which are loaded at a time
export const MEMBERS_PAGE_SIZE = 1000;
// How long to wait after the last keystroke before searching for members which aren't held
export const FIND_MEMBERS_DELAY_MS = 300;
// Bump this when the platform terms change: users whose recorded acceptance is below this
// version are shown a blocking terms-updated notice and must affirmatively accept.
export const CURRENT_TERMS_VERSION = 2;
// The user canister rejects a longer bio (MAX_BIO_LEN in user_core set_bio.rs)
export const MAX_BIO_LENGTH = 2000;
